module.exports = __webpack_public_path__ + "static/kryptonitehome-16ef39807734995dec7fae874b9fe24f.jpg";